import getFeedPrivacyIcon from 'components/feed/Feed/Header/helpers/getPrivacyIcon'

import { Privacy } from '../../../ControlsBar/PrivacyDropdown/types'

const getPostReplyPrivacy = (showInheritOption: boolean): Privacy[] =>
  [
    showInheritOption && {
      key: 'FOLLOW_POST',
      label: 'Inherited',
      description: 'Visible to post audience',
      icon: (size = 20, isActive = false) =>
        getFeedPrivacyIcon('FOLLOW_POST', isActive, size),
    },
    {
      key: 'PUBLIC',
      label: 'Public',
      description: 'Visible to everyone',
      icon: (size = 20, isActive = false) =>
        getFeedPrivacyIcon('PUBLIC', isActive, size),
    },
    {
      key: 'UNLISTED',
      label: 'Unlisted',
      description: 'Visible on profile only, search excluded',
      icon: (size = 20, isActive = false) =>
        getFeedPrivacyIcon('UNLISTED', isActive, size),
    },
    {
      key: 'PRIVATE',
      label: 'Followers',
      description: 'Visible to followers only',
      icon: (size = 20, isActive = false) =>
        getFeedPrivacyIcon('PRIVATE', isActive, size),
    },
    {
      key: 'DIRECT',
      label: 'Direct',
      description: 'Visible to mentioned user only',
      icon: (size = 20, isActive = false) =>
        getFeedPrivacyIcon('DIRECT', isActive, size),
    },
  ].filter((v) => v) as Privacy[]

export default getPostReplyPrivacy
